import aT from '../const/action-type'

export default (data) => {
  return { type: aT.FINISHED_LOADING, data }
}
